// extracted by mini-css-extract-plugin
module.exports = {"avatar":"PrincipalEditorControl_avatar__7GJtn","name":"PrincipalEditorControl_name__2RE1L"};